import actions from './actions';

const initState = {
  user: null,
  loading: false,
  error: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_USER_SUCCESS:
      return {
        ...state,
        user: action.user,
        loading: false,
        error: null,
      };
    case actions.GET_USER_ERROR:
      return {
        ...state,
        user: null,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
